import { useEffect, useState } from 'react'




const MapInfoView = () => {
    useEffect(() => {
        const map = null;
        const initMap = () => {
            const mapOptions  = new naver.maps.Map('map', {
                center: new naver.maps.LatLng(37.524040713354, 127.04823594794),
                zoom: 15,
                logoControl: false,
                minZoom: 6,
                maxZoom: 15
             });
             const maker = new naver.maps.Marker({
                position: new naver.maps.LatLng(37.524040713354, 127.04823594794),
                map: mapOptions
             })
        };
        initMap();
    }, [])

    const mapStyle = {
        width: '100%',
        height: '100%',
    };

    return (
<div className="
  flex flex-col laptop:flex-row              
  gap-10                         
  max-w-screen-desktop mx-auto   
  tablet: 6px laptop:px-56 py-12 desktop:px-0
">
  <div
    id="map"
    className="
      w-full h-[372px] desktop:w-[900px] laptop:w-1/2   
      rounded-lg
      shadow-lg
      overflow-hidden
    "
  />

  <div className="

      w-full h-auto
      laptop:w-1/2
      desktop:w-[900px]
      bg-white                    
      rounded-lg
      shadow-lg
      p-8
      flex flex-col
      space-y-4
    ">

    <img
      src="/assets/images/main_logo.png"
      alt="TheReal 로고"
      className="w-32 mx-auto mb-4"
    />
    <div className='font-sans'>
      <h4 className="text-lg font-bold text-black">주소</h4>
      <p className="text-gray-500 text-pretty whitespace-pre-line">
        {`서울특별시 강남구 도산대로 506, 7층\n(청담동 48-2, 재정빌딩)`}
      </p>
    </div>

    <div className='font-sans'>
      <h4 className="text-lg font-bold text-black">전화</h4>
      <p className="text-gray-500 text-pretty">02-540-3111</p>
    </div>

    <div className='font-sans'>
      <h4 className="text-lg font-bold text-black">이메일</h4>
      <p className="text-gray-500 text-pretty">sonmagic@realmkt.co.kr</p>
    </div>
  </div>
</div>


    )
}

export default MapInfoView